import { defineComponent } from "vue";
import { isAex, aexLogo } from "@/brand";

import { COMPONENT_NAME, SVG } from "./attributes";

export default defineComponent({
  name: COMPONENT_NAME,
  computed: {
    displayedLogo(): string {
      return isAex ? aexLogo : SVG.logo;
    },
  },
});
